var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8c0d315c0747a38eaaee3fad0ad0f77cda15bc60"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["cloud-frontend@materializeinc"]={id:"8c0d315c0747a38eaaee3fad0ad0f77cda15bc60"};
      